export default {
  enName (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^[_a-zA-Z0-9]+$').test(value)) {
        callback(new Error('只能由数字、字母、下划线组成'))
      }
    }
    callback()
  },
  cnName (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^[_a-zA-Z0-9\\u4e00-\\u9fa5]+$').test(value)) {
        callback(new Error('只能由数字、字母、中文、下划线组成'))
      }
    }
    callback()
  },
  cnSoftwareName (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^[-_a-zA-Z0-9\\u4e00-\\u9fa5]+$').test(value)) {
        callback(new Error('只能由数字、字母、中文、中划线、下划线组成'))
      }
    }
    callback()
  },
  nonCn (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (new RegExp('[\u4e00-\u9fa5]').test(value)) {
        callback(new Error('只能由非中文组成'))
      }
    }
    callback()
  }
}
